export default __webpack_public_path__ + "static/media/drone_dark.ecddeda4.png";